export enum ActionTypes {
  LOAD_ADDRESS_REQUEST = 'LOAD_ADDRESS_REQUEST',
  LOAD_ADDRESS_SUCCEEDED = 'LOAD_ADDRESS_SUCCEEDED',
  LOAD_ADDRESS_FAILED = 'LOAD_ADDRESS_FAILED',
}
